const DarkSelectStyles = {
  control:  (styles) => {
    return {
      ...styles,
      backgroundColor: '#000',
      borderWidth: '0.25px',
      color: '#fff',
      border: '0.5px solid #fff',
      borderRadius: 'none',
      '&:hover': {
        boxShadow: 'unset',
      },
      '&:focus': {
        boxShadow: 'unset',
      },
      '&:focus-within': {
        boxShadow: 'unset',
      },
      '&:active': {
        boxShadow: 'unset',
      },
    };
  },
  option: (styles) => ({ ...styles, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.5)', '&:hover': { backgroundColor: 'gray' }}),
  singleValue: (styles) => {
    return {
      ...styles,
      color: '#fff',
      fontSize: '14px',
      letterSpacing: '0.05em',
      fontWeight: 300,
    };
  },
  indicatorSeparator: (styles) => ({ ...styles, backgroundColor: 'transparent' }),
  dropdownIndicator: (styles) => ({ ...styles, color: '#fff', '&:hover': { color: '#fff' }}),
  menu:  (styles) => ({...styles, backgroundColor: '#000', zIndex: '2000'}),
  input:(styles) => ({...styles, color: '#fff', '&:hover': { border: '0.5px solid #fff' }}),
};

export const TransparentSelectStyles = {
  control: (styles) => {
    return {
      ...styles,
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: 'none',
      justifyContent: 'center',
      width: '115px',
      margin: 'auto',
      '&:hover': {
        boxShadow: 'unset',
      },
      '&:focus': {
        boxShadow: 'unset',
      },
      '&:focus-within': {
        boxShadow: 'unset',
        border: '0.5px solid rgba(255, 255, 255, 1)',
      },
      '&:active': {
        boxShadow: 'unset',
      },
    };
  },
  option: (styles) => {
    return {
      ...styles,
      color: 'white',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      '&:hover': {
        backgroundColor: 'gray',
      },
    };
  },
  singleValue: (styles, {data}) => {
    return {
      ...styles,
      color: data.label === 'Inactive' ? 'rgba(203, 37, 122, 1)' : '#fff',
      fontSize: '14px',
      letterSpacing: '0.05em',
      fontWeight: 400,
    };
  },
  valueContainer: (styles) => ({...styles, justifyContent: 'center'}),
  dropdownIndicator: (styles, {isFocused}) => ({ ...styles, color: '#fff', '&:hover': { color: '#fff' }, display: isFocused ? 'block' : 'none'}),
  indicatorSeparator: (styles) => ({ ...styles, display: 'none'}),
  menu: (styles) => ({ ...styles, backgroundColor: '#000', zIndex: '2000'}),
  input: (styles) => ({ ...styles, color: '#fff', width: '115px'}),
  menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
};

export default DarkSelectStyles;
